<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <div class="Top_btn">
          <div>
            <el-form inline>
              <el-form-item label="商品">
                <el-input v-model="SPproductName" type="textarea" :rows="3" style="width: 300px"
                  placeholder="商品(选填，可模糊，一行一个)" clearable size="mini"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" @click="librarycreateTaskListFun()">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type='warning' size="mini" @click="openSyncProductFun()">同步商品</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" @click="fastCheckFun()">按照专辑链接快速过滤</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-button type="primary" size="mini" @click="checkSU()">确定</el-button>
          </div>
        </div>

        <div>
          <el-table :data="libraryebpProductListData" border style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="productName" label="商品名称"> </el-table-column>
            <el-table-column prop="playletId" label="专辑id"> </el-table-column>
            <el-table-column prop="productId" label="商品id"> </el-table-column>

            <!-- <el-table-column prop="sub_category" label="商品id" width="180"> </el-table-column> -->
            <!-- <el-table-column prop="first_category" label="一级" width="180"> </el-table-column>
            <el-table-column prop="sub_category" label="二级" width="180"> </el-table-column>
            <el-table-column prop="third_category" label="三级" width="180"> </el-table-column> -->
            <!-- <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="180"> </el-table-column>
            <el-table-column prop="errorMsg" label="错误信息"> </el-table-column> -->
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
            :pagesize="pagesize" :currentPage="currentPage"></pagination>
        </div>
      </el-card>
    </div>

    <!-- 同步商品弹窗（借鉴 spgl.vue） -->
    <el-dialog title="同步商品" v-model="syncProductView" width="40%" append-to-body>
      <el-form label-width="120px">
        <el-form-item label="商品名称:">
          <el-input v-model="syncProductName" placeholder="单个商品名称(选填，可模糊)，不填为根据数量同步商品" clearable
            size="mini"></el-input>
        </el-form-item>
        <el-form-item label="最大同步数量:">
          <el-input-number v-model="syncMaxCount" :min="1" :max="5000" size="mini"></el-input-number>
          <div style="color:#999;font-size:12px;margin-top:4px;">最大5000，默认500</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="mini" @click="syncProductView = false">取消</el-button>
        <el-button type="primary" size="mini" @click="confirmSyncProductFun()">确定</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>

import { libraryebpProductList, libraryebpProductSync, librarycreateTaskList } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件

export default {
  name: 'ylySelectProducts',
  components: { pagination },
  props: ['data'],
  emits: ['SPproductData'],
  setup(props, { emit }) {

    const state = reactive({
      // 查询商品的搜索的商品名称
      SPproductName: '',
      libraryebpProductListData: [],
      // 获取选中的值
      SPproductData: [],
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        librarycreateTaskListFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        librarycreateTaskListFun()
      },
      // 同步商品
      libraryebpProductSyncFun: () => {
        const datas = {
          productPlatformId: props.data.productPlatformId,
          accountId: props.data.accountId,
        }
        libraryebpProductSync(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      // 同步商品弹窗（借鉴 spgl.vue）
      syncProductView: false,
      syncProductName: '',
      syncMaxCount: 500,
      openSyncProductFun: () => {
        state.syncProductName = ''
        state.syncMaxCount = 500
        state.syncProductView = true
      },
      confirmSyncProductFun: () => {
        const maxSyncCount = Math.min(Number(state.syncMaxCount) || 500, 5000)
        const datas = {
          productPlatformId: props.data.productPlatformId,
          accountId: props.data.accountId,
          productName: state.syncProductName || null,
          maxSyncCount,
        }
        libraryebpProductSync(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
            state.syncProductView = false
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      // 按照专辑链接快速选择
      fastCheckFun: () => {
        if (props.data.productNames.length == 0) {
          ElMessage.warning('请先选择专辑链接')
        } else {
          console.log('ylySelectProducts.props.data', props.data)
          const datas = {
            page: state.currentPage,
            pageSize: state.pagesize,
            platformId: props.data.productPlatformId,
            accountId: props.data.accountId,
            productNames: props.data.productNames
          }
          librarycreateTaskList(datas).then((res) => {
            // state.SPproductData = res.data.data
            state.libraryebpProductListData = res.data.data
            state.currentPage = res.data.currenPage
            state.total = res.data.totalSize
          })

        }
      },
      // 确定
      checkSU: () => {
        if (state.SPproductData.length > 0) {
          const datas = state.SPproductData.map((item) => ({
            productName: item.productName,
            productId: item.productId,
            playletId: item.playletId,
            productLibraryId: props.data.productPlatformId,
          })
          )
          console.log('ylySelectProducts.checkSU', datas)
          emit('SPproductData', JSON.parse(JSON.stringify(datas)))
        } else {
          ElMessage.error('请先选择商品')
        }

      }
    })


    const getProductNames = () => {
      if (!state.SPproductName) return []
      return state.SPproductName
        .split(/\n+/)
        .map((line) => line.trim().replace(/\s+/g, ''))
        .filter((line) => line)
    }

    const librarycreateTaskListFun = () => {
      console.log('librarycreateTaskListFun', props.data)
      const productNames = getProductNames()
      const datas = {
        currentPage: state.currentPage,
        size: state.pagesize,
        platformId: props.data.productPlatformId,
        accountId: props.data.accountId,
        // productName: productNames.length === 1 ? productNames[0] : null,
        ...(productNames.length ? { productNames } : {}),
      }

      librarycreateTaskList(datas).then((res) => {
        state.libraryebpProductListData = res.data.data
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
      })
    }

    librarycreateTaskListFun()

    // const libraryebpProductListFun = () => {
    //   console.log('libraryebpProductListFun', props.data)
    //   const datas = {
    //     page: state.currentPage,
    //     pageSize: state.pagesize,
    //     productPlatformId: props.data.productPlatformId,
    //     accountId: props.data.accountId,
    //     productName: state.SPproductName || null,
    //   }

    //   libraryebpProductList(datas).then((res) => {
    //     state.libraryebpProductListData = res.data.list
    //     state.currentPage = res.data.pageInfo.page
    //     state.total = res.data.pageInfo.totalNumber
    //   })
    // }

    // libraryebpProductListFun()


    // 获取复选框的值
    const handleSelectionChange = (val) => {
      console.log('获取复选框的值', val)
      state.SPproductData = val
      // state.sId = []
      // val.forEach((item) => {
      //   state.sId.push(item.id)
      // })
    }

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      // libraryebpProductListFun,
      handleSelectionChange,
      librarycreateTaskListFun,
    }
  },
}
</script>

<style lang="scss" scoped>
.Top_btn {
  display: flex;
  justify-content: space-between;
}
</style>
